const iconBase = L.Icon.extend({
	options: {
		shadowUrl: 'assets/images/mapicons/pin-shadow.png',
		iconSize:     [26, 26],
		shadowSize:   [30, 8],
		iconAnchor:   [13, 17],
		shadowAnchor: [14, -2],
		popupAnchor:  [0, -26]
	}
});

const icon = {
	servicios: new iconBase({iconUrl: 'assets/images/mapicons/pin-servicios.svg'}),
	restaurantes: new iconBase({iconUrl: 'assets/images/mapicons/pin-restaurantes.svg'}),
	habitaciones: new iconBase({iconUrl: 'assets/images/mapicons/pin-habitaciones.svg'}),
	recreativo: new iconBase({iconUrl: 'assets/images/mapicons/pin-recreativo.svg'})
};

export {iconBase, icon};